<template>
  <div class="update-content">
    <div class="update-item">
      <div class="update-item__info ql-container ql-snow" style="border-width: 0;">
        <zoom-image
          v-if="isShowImg"
          class="update-item__button-img"
          imageHeight="350"
          :src="update.photoUrl"
          :alt="update.title" />
        <div v-html="update.description" class="update-item__text ql-editor" />
      </div>
      <div class="update-item__buttons-control">
        <div class="update-item__buttons-actions">
          <button
            v-if="isLinkButton"
            type="button"
            class="update-item__link-anchor"
            @click="onClickLinkAnchor(update.linkAnchor)">
            Перейти
          </button>
          <button
            class="update-item__button"
            type="button"
            @click="onClose"
            v-if="isLastItem && isShowNextButton">
            Отлично
          </button>
          <button
            class="update-item__button"
            type="button"
            @click="onClickNextButton"
            v-else-if="isShowNextButton">
            Далее
          </button>
        </div>
        <div class="update-item__vote">
          <button
            type="button"
            class="update-item__vote__button like"
            v-bind:class="{ active: $options.voteLike === update.vote }"
            v-bind:disabled="$options.voteLike === update.vote"
            v-on:click="onUpdateVote($options.voteLike)" />
          <button
            type="button"
            class="update-item__vote__button dislike"
            v-bind:class="{ active: $options.voteDislike === update.vote }"
            v-bind:disabled="$options.voteDislike === update.vote"
            v-on:click="onUpdateVote($options.voteDislike)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Update } from '@/storage/gateways/UpdatesGateway';
import ZoomImage from '@/components/ZoomImage.vue';

/**
 * Переключиться на следующие нововведение.
 *
 * @type {string}
 */
const NEXT_ITEM = 'next-item';

/**
 * Перейти по ссылки нововведения.
 *
 * @type {string}
 */
const REDIRECT = 'redirect';

/**
 * Название события закрытия.
 *
 * @type {string}
 */
const EVENT_NAME_CLOSE = 'close';

/**
 * @description Название события обновления оценки обновления.
 * @type {string}
 */
const EVENT_NAME_UPDATE_VOTE = 'update';

export default {
  voteLike: 'like',
  voteDislike: 'dislike',
  name: 'UpdateItem',
  components: {
    ZoomImage,
  },
  computed: {
    /**
     * Показывать ли изображение
     *
     * @return {boolean}
     */
    isShowImg() {
      return this.update.photoUrl !== '';
    },
    /**
     * Показывать ли кнопку "Перейти"
     *
     * @return {boolean}
     */
    isLinkButton() {
      return this.update.linkAnchor !== '';
    },
    updateId() {
      return this.update.id;
    },
  },
  data() {
    return {
      vote: this.update.vote,
    };
  },
  methods: {
    /**
     * Обработать событие нажатия по кнопке "Далее"
     * @return {void}
     */
    onClickNextButton() {
      this.$emit(NEXT_ITEM);
    },
    /**
     * Обработать событие нажатия по кнопке "Подробнее"
     * @return {void}
     */
    onClickLinkAnchor(link) {
      this.$emit(REDIRECT, link);
    },
    /**
     * @description Обработать событие закрытия.
     * @returns {void}
     */
    onClose() {
      this.$emit(EVENT_NAME_CLOSE);
    },
    /**
     * @description Обработать событие обновления оценки.
     * @returns {void}
     */
    onUpdateVote(vote) {
      this.$emit(EVENT_NAME_UPDATE_VOTE, this.update.id, vote);
    },
  },
  props: {
    /**
     * Обновление
     * @type Update
     */
    update: {
      type: Update,
      required: true,
    },
    /**
     * Показывать ли кнопку "Далее"
     * @type boolean
     */
    isShowNextButton: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    /**
     * Последний элемент.
     * @type boolean
     */
    isLastItem: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/quillEditorLib.css";
.update-content {
  height: 100%;
  padding: 10px 0;
}
.update-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 10px;
  text-align: left;
  ::v-deep p {
    display: block;
  }
  &__buttons-control {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-inline: 12.5%;
  }
  &__buttons-actions {
    display: flex;
    justify-content: center;
    gap: 65px;
  }
  &__button-img{
    width: 100%;
    height: 350px;
    ::v-deep img {
      padding: 0;
      max-height: 100%;
      object-fit: contain;
    }
  }
  &__text {
    height: fit-content;
  }
  &__link-anchor {
    text-align: center;
    height: 50px;
    padding: 10px;
    width: 220px;
    font-size: 18px;
    text-decoration: none;
    color: white;
    background-color: #1F85C8;
    border-radius: 15px;
    &:hover{
      transition: 0.5s;
      color: #1F85C8;
      background-color: white;
      border: solid #1F85C8 1px;
    }
  }
  &__button {
    text-align: center;
    height: 50px;
    padding: 10px;
    width: 120px;
    font-size: 18px;
    text-decoration: none;
    border: solid #1F85C8 1px;
    color: #1F85C8;
    background-color: white;
    border-radius: 15px;
    &:hover{
      transition: 0.5s;
      color: white;
      background-color: #1F85C8;
    }
  }
  &__info {
    padding: 10px;
    max-height: 450px;
    overflow-y: auto;
    &__title {
      font-weight: bold;
      font-size: 24px;
    }
  }
  &__vote {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: 25px;
    margin-right: 10px;
    &__button {
      cursor: pointer;
      background-size: contain;
      width: 21px;
      height: 20px;
      &.like {
        background-image: url("@/assets/img/like-grey.svg");
        &.active,
        &:hover {
          background-image: url("@/assets/img/like-green.svg");
        }
      }
      &.dislike {
        background-image: url("@/assets/img/dislike-grey.svg");
        &.active,
        &:hover {
          background-image: url("@/assets/img/dislike-red.svg");
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .update-item {
    &__buttons-control {
      flex-direction: column;
      row-gap: 15px;
      padding-inline: 20px;
    }
    &__buttons-actions {
      gap: 10px;
    }
    &__vote {
      position: static;
      align-self: flex-end;
      margin-right: 0;
    }
  }
}
</style>
